import React, { useState } from "react";

const AddPainting = () => {
  const [responseMsg, setResponseMsg] = useState("");
  const [previewImages, setPreviewImages] = useState({ base: null, wall: null });

  const handleImagePreview = (event, type) => {
    const file = event.target.files[0];
    if (file) {
      setPreviewImages(prev => ({ ...prev, [type]: URL.createObjectURL(file) }));
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.target;
    const formData = new FormData();

    const painting = {
      title: form.title.value,
      series: form.series.value,
      seriesDescription: form.seriesDescription.value, // ✅ New Series Description
      year: form.year.value,
      price: form.price.value,
      size: form.size.value,
      material: form.material.value,
      artist: form.artist.value,
      story: form.story.value,
      offer: form.offer.value,
      category: form.category.value, 
    };

    formData.append("painting", new Blob([JSON.stringify(painting)], { type: "application/json" }));
    
    // ✅ Specifically append Base and Wall images
    formData.append("images", form.baseImage.files[0]);
    formData.append("images", form.wallImage.files[0]);

    try {
      const res = await fetch("http://localhost:8080/api/paintings/add", {
        method: "POST",
        body: formData,
      });

      if (!res.ok) throw new Error("Failed to add painting");

      const data = await res.json();
      setResponseMsg(`✔ Painting added successfully! ID: ${data.id}`);
      form.reset();
      setPreviewImages({ base: null, wall: null });
    } catch (err) {
      console.error("Upload Error:", err);
      setResponseMsg("❌ Error adding painting.");
    }
  };

  return (
    <div style={{ padding: "40px", maxWidth: "700px", margin: "auto" }}>
      <h1>Add a New Painting</h1>

      <form id="paintingForm" onSubmit={handleSubmit} encType="multipart/form-data">
        
        <label>Category (e.g., Mythological, Positive Energy, Innovations):</label>
        <input type="text" name="category" required style={inputStyle} />

        <label>Title:</label>
        <input type="text" name="title" required style={inputStyle} />

        <label>Series Name:</label>
        <input type="text" name="series" style={inputStyle} />

        <label>Series Description:</label>
        <textarea name="seriesDescription" rows="3" style={inputStyle} placeholder="Describe the series narrative..."></textarea>

        <label>Year:</label>
        <input type="number" name="year" style={inputStyle} />

        <label>Price:</label>
        <input type="number" step="0.01" name="price" style={inputStyle} />

        <label>Size:</label>
        <input type="text" name="size" style={inputStyle} />

        <label>Material:</label>
        <input type="text" name="material" style={inputStyle} />

        <label>Artist:</label>
        <input type="text" name="artist" style={inputStyle} />

        <label>Story:</label>
        <textarea name="story" rows="4" style={inputStyle}></textarea>

        <label>Offer:</label>
        <input type="text" name="offer" style={inputStyle} />

        {/* ✅ Image Uploads */}
        <div style={{ display: "flex", gap: "20px", marginBottom: "20px" }}>
            <div style={{ flex: 1 }}>
                <label>Image 1 (Base Painting):</label>
                <input type="file" name="baseImage" accept="image/*" required onChange={(e) => handleImagePreview(e, 'base')} />
                {previewImages.base && <img src={previewImages.base} width="100" style={{ display: "block", marginTop: "10px" }} />}
            </div>
            <div style={{ flex: 1 }}>
                <label>Image 2 (Wall Mockup):</label>
                <input type="file" name="wallImage" accept="image/*" onChange={(e) => handleImagePreview(e, 'wall')} />
                {previewImages.wall && <img src={previewImages.wall} width="100" style={{ display: "block", marginTop: "10px" }} />}
            </div>
        </div>

        <button type="submit" style={btnStyle}>Add Painting</button>
      </form>
      <p style={{ marginTop: "20px", fontWeight: "bold" }}>{responseMsg}</p>
    </div>
  );
};

const inputStyle = { width: "100%", padding: "10px", marginBottom: "15px", border: "1px solid #ccc", borderRadius: "4px" };
const btnStyle = { padding: "12px 24px", background: "#222", color: "#fff", border: "none", cursor: "pointer", width: "100%", borderRadius: "4px" };

export default AddPainting;